import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

const heroVisibilitySubject$ = new BehaviorSubject(false);

/**
 * Sets up an IntersectionObserver to observe the visibility of the hero section.
 * Emits visibility changes through heroVisibilitySubject$.
 */
function setHeroSectionIntersectionObserver() {
  const heroSection = document.querySelector('[data-news-and-trends-hero]');
  if (heroSection) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        heroVisibilitySubject$.next(entry.isIntersecting);
      });
    }, {
      rootMargin: '-56px 0px 0px 0px' // Trigger 5px before the hero section is out of view
    });

    observer.observe(heroSection);
  }
}

/**
 * Toggles the 'is-sticky' class on the navbar based on the visibility of the hero section.
 * Also toggles the 'nhs-u-pointer-events--none' class on the header when the navbar is sticky.
 * @param {boolean} isVisible - Indicates whether the hero section is visible.
 */
function toggleStickyNavbar(isVisible) {
  const navbar = document.querySelector('[data-news-and-trends-navbar]');
  const header = document.querySelector('[data-header-layout]');

  if (navbar) {
    navbar.classList.toggle('nhs-c-navbar--sticky', !isVisible);

    // Add or remove the 'nhs-u-pointer-events--none' class on the header
    if (header) {
      header.classList.toggle('nhs-u-pointer-events--none', navbar.classList.contains('nhs-c-navbar--sticky'));
    }
  }
}

// Subscribe to heroVisibilitySubject$ to handle visibility changes and toggle the sticky class on the navbar
heroVisibilitySubject$
  .pipe(distinctUntilChanged())
  .subscribe(toggleStickyNavbar);

// Set up the intersection observer when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', setHeroSectionIntersectionObserver);